import { ACCOUNT_REQUEST, CREATE_ACCOUNT, GET_ACCOUNT, UPDATE_ACCOUNT, DELETE_ACCOUNT, ACCOUNT_REQUEST_FAILURE, GET_ACCOUNTS_PAGE,
  ACCOUNT_REQUEST_SUCCESS, UPDATE_ACCOUNT_IN_LIST, ADD_ACCOUNT_IN_LIST, DELETE_ACCOUNT_IN_LIST } from '../types';
import * as _ from 'lodash';

const initialState = {
  accounts: [],
  accountsPage: [],
  loading: false,
  page: 1,
  pageSize: 10,
  search: '',
  where: {},
  total: 0,
  loading: false,
  error: null,
};

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACCOUNT_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_ACCOUNT: {
      return {
        ...state,
        accounts: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_ACCOUNTS_PAGE: {
      const { data, total, page, pageSize, search, where } = action.payload || {};
      return {
        ...state,
        accountsPage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
      }
    }
    case CREATE_ACCOUNT:
      return {
        ...state,
        accounts: [action.payload, ...state.accounts],
        loading: false,
        error: null
      };
    case UPDATE_ACCOUNT:
      const accountsData = state.accounts.slice(0);
      const uIndex = accountsData.findIndex((data) => data.id === action.payload.id);
      accountsData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        accounts: [ ...accountsData ],
        loading: false,
        error: null
      };
    case DELETE_ACCOUNT:
      const accounts = state.accounts?.slice(0);
      const index = accounts.findIndex((data) => data.id === action.id);
      if (index > -1) {
        accounts.splice(index, 1);
      }
      return {
        ...state,
        accounts: [...accounts],
        loading: false,
        error: null
      }
    case ACCOUNT_REQUEST_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: null
        }
      }
    case ACCOUNT_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    case UPDATE_ACCOUNT_IN_LIST: {
      const accId = parseInt(action.payload?.id) || 0;
      const data = action.payload?.data;
      const accountsData = state.accounts?.slice(0) || [];
      const accountsPageData = state.accountsPage?.slice(0) || [];
      if (data) {
        if (accountsData?.length) {
          const index = accountsData.findIndex((val) => val.id === accId);
          if (index > -1) {
            accountsData.splice(index, 1, data);
          }
        }
        if (accountsPageData?.length) {
          const indexPage = accountsPageData.findIndex((val) => val.id === accId);
          if (indexPage > -1) {
            accountsPageData.splice(indexPage, 1, data);
          }
        }
      }

      return {
        ...state,
        accounts: accountsData,
        accountsPage: accountsPageData
      }
    }
    case ADD_ACCOUNT_IN_LIST: {
      const data = action.payload?.data;
      const accountsData = state.accounts?.slice(0) || [];
      const accountsPageData = state.accountsPage?.slice(0) || [];
      if (data) {
        accountsData.push(data);
        accountsPageData.push(data);
      }

      return {
        ...state,
        accounts: _.orderBy(accountsData, ['Party_Name'], ['asc']),
        accountsPage: _.orderBy(accountsPageData, ['Party_Name'], ['asc']),
      }
    }
    case DELETE_ACCOUNT_IN_LIST: {
      const accId = parseInt(action.payload?.id) || 0;
      const accountsData = state.accounts?.slice(0) || [];
      const accountsPageData = state.accountsPage?.slice(0) || [];
      if (accId) {
        if (accountsData?.length) {
          const index = accountsData.findIndex((val) => val.id === accId);
          if (index > -1) {
            accountsData.splice(index, 1);
          }
        }
        if (accountsPageData?.length) {
          const indexPage = accountsPageData.findIndex((val) => val.id === accId);
          if (indexPage > -1) {
            accountsPageData.splice(indexPage, 1);
          }
        }
      }

      return {
        ...state,
        accounts: accountsData,
        accountsPage: accountsPageData
      }
    }
    default:
      return state;
  }
};

export default accountReducer;
